import type { RoleScopedUser } from 'app/types/location-access'

/**
 * A task is assigned to a user (`ownerId`) or a role (`roleId`), never both.
 * Owner pickers hand back one id string, so a role rides through them as `role:<roleId>`.
 */
export const ROLE_ASSIGNEE_PREFIX = `role:`

export function assigneeInput(value: string | null | undefined) {
  if (!value) return { ownerId: null, roleId: null }
  if (value.startsWith(ROLE_ASSIGNEE_PREFIX)) return { ownerId: null, roleId: value.slice(ROLE_ASSIGNEE_PREFIX.length) }
  return { ownerId: value, roleId: null }
}

export function taskAssigneeValue(task: { ownerId?: string | null; roleId?: string | null }) {
  if (task.roleId) return `${ROLE_ASSIGNEE_PREFIX}${task.roleId}`
  return task.ownerId ?? undefined
}

/** A user holds one role per workspace; org-level users carry theirs on the top-level `roleId`. */
export function myRoleId(user: RoleScopedUser, workspaceId?: string) {
  const inWorkspace = user.workspaces?.find((workspace) => workspace.id === workspaceId)?.roleId
  return inWorkspace ?? user.roleId ?? undefined
}

/** Ids are phrase-quoted: ES splits unquoted ids on hyphens. */
export function myTasksSearch(userId: string, roleId?: string) {
  const mine = `ownerId:"${userId}"`
  return roleId ? `(${mine} OR roleId:"${roleId}")` : mine
}
